/**
 * Arduino Customer Tracking Events
 */

(function() {
    function publishCollectionEvent(eventHandle, collectionName, collectionElement) {
        const productsJson = collectionElement.querySelectorAll('[data-arduino-tracking]');
        const products = [];
    
        for(let product of productsJson) {
            products.push(JSON.parse(product.innerHTML));
        }
    
        const payload = {
            collection: {id: '', title: collectionName},
            currency: Shopify.currency.active,
            products: products
        };
    
        Shopify.analytics.publish(eventHandle, payload);
    }

    function publishSelectItemEvent(event) {
        const productElement = event.currentTarget.closest('[data-product-item-content]');
        const productJson = productElement.querySelector('[data-arduino-tracking]');

        const collection = {
            id: '',
            name: ''
        };

        if(productJson.dataset.arduinoTrackingCollectionId && productJson.dataset.arduinoTrackingCollectionName) {
            collection.id = productJson.dataset.arduinoTrackingCollectionId;
            collection.name = productJson.dataset.arduinoTrackingCollectionName;
        }

        if(productJson) {
            const payload = {
                currency: Shopify.currency.active,
                collection: collection,
                products: [JSON.parse(productJson.innerHTML)]
            };

            Shopify.analytics.publish('select_item', payload);
        }
    }

    function publishAddToWishListEvent(event) {
        const productElement = event.currentTarget.closest('.iwishAddWrap');
        const productJson = productElement.querySelector('[data-arduino-tracking]');

        const collection = {
            id: '',
            name: ''
        };

        if(productJson.dataset.arduinoTrackingCollectionId && productJson.dataset.arduinoTrackingCollectionName) {
            collection.id = productJson.dataset.arduinoTrackingCollectionId;
            collection.name = productJson.dataset.arduinoTrackingCollectionName;
        }

        if(productJson) {
            const payload = {
                currency: Shopify.currency.active,
                collection: collection,
                products: [JSON.parse(productJson.innerHTML)]
            };

            Shopify.analytics.publish('add_to_wishlist', payload);
        }
    }

    function publishMenuHeaderClickEvent(event) {
        const payload = {
            link_text: event.target.innerHTML.trim(),
            link_url: event.target.href
        };

        Shopify.analytics.publish('menu_header_click', payload);

        window.location = event.target.href;
    }

    function publishAbTestAssignment() {
        const element = document.querySelector('script[data-treatment-ids]');
        const treatmentIds = element?.dataset.treatmentIds || null;

        if(treatmentIds) {
            const payload = {
                page: window.location.pathname,
                treatment_ids: treatmentIds
            };

            Shopify.analytics.publish('ab_test_assignment', payload);
        }
    }

    function init() {
        // featured collection views tracking
        const featuredCollection = document.querySelector('[data-featured-collection]');

        if(featuredCollection) {
            publishCollectionEvent('featured_collection_view', 'Homepage Featured collection', featuredCollection);
        }

        // product recommendations views tracking
        const productRecommendations = document.querySelector('[data-product-recommendations]');

        if(productRecommendations) {
            publishCollectionEvent('product_recommendations_view', 'Product Recommendation section', productRecommendations);
        }

        // select item tracking
        const productPageLinks = document.querySelectorAll('[data-product-page-link]');

        for(let link of productPageLinks) {
            link.addEventListener('click', publishSelectItemEvent);
        }

        // add to wish list tracking
        const addToWishListButtons = document.querySelectorAll('.iWishAdd, .iWishAddColl');

        for(let button of addToWishListButtons) {
            button.addEventListener('click', publishAddToWishListEvent);
        }

        // menu header link tracking
        const menuHeaderLinks = document.querySelectorAll('#ino-header .ino-menu--desktop a, #ino-header .ino-menu--mobile a');

        for(let link of menuHeaderLinks) {
            link.addEventListener('click', publishMenuHeaderClickEvent);
        }

        // ab test tracking
        publishAbTestAssignment();
    }

    window.addEventListener('load', init);
})();